import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuthStore } from "../store/store";
import Spinner from "react-bootstrap/Spinner";

const Impersonate = () => {
    const navigate = useNavigate();
    const { setToken, setUser } = useAuthStore();
    const [error, setError] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token");

        if (!token) {
            setError("No token provided.");
            return;
        }

        axios
            .post(`${process.env.REACT_APP_API_URL}/api/impersonate`, { token })
            .then(res => {
                setToken(res.data.token);
                setUser(res.data.user);
                navigate("/podcaster-dashboard", { replace: true });
            })
            .catch(err => {
                setError(err.response?.data?.message || "Invalid or expired link.");
            });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (error) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="text-center">
                    <p className="text-danger mb-2">{error}</p>
                    <small className="text-muted">This link may have expired. Ask the admin to generate a new one.</small>
                </div>
            </div>
        );
    }

    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <Spinner animation="border" />
        </div>
    );
};

export default Impersonate;
